import { React } from "react";
import CaseListList from "../../../../components/cm/Dashboard/FullPages/CaseList/CaseListList/CaseListList";
import SideBarMain from "../../../../components/cm/SideBarMain";
import AppWrapper from "../../../../components/cm/AppWrapper";

export default () => {
  return (
    <AppWrapper.WithSidebar
      sidebar={<SideBarMain />}
    >
      <CaseListList
        customBaseDetailPath={"/finance/cases/"}
        customBaseDetailSegment={"/details"}
      />
    </AppWrapper.WithSidebar>
  );
};
